import { useQuery } from '@tanstack/react-query';
import { getAiStatus } from '../api/ai.js';
import { useAuthStore } from '../store/auth-store.js';

export const AI_STATUS_QUERY_KEY = ['ai', 'status'] as const;

/**
 * Whether AI is on for this server and how much of today's allowance the
 * workspace has used. Shared by the header badge, the schedule dialog, the
 * AI page and Settings; only asked once a session is signed in (a 401 here
 * would log the person out through the HTTP interceptor).
 */
export function useAiStatus() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  return useQuery({
    queryKey: AI_STATUS_QUERY_KEY,
    queryFn: getAiStatus,
    enabled: isAuthenticated,
    staleTime: 60_000,
    retry: false,
  });
}
